<mat-toolbar>
    @if (isHost()) {
        <span class="logo-link">
            <ng-container [ngTemplateOutlet]="logo"></ng-container>
        </span>
    } @else {
        <a routerLink="/" class="logo-link">
            <ng-container [ngTemplateOutlet]="logo"></ng-container>
        </a>
    }
    <ng-template #logo>
        <img
            ngSrc="assets/SiriusXM-Logo-onLight.svg"
            alt="SiriusXM"
            height="20"
            width="105"
            priority
        />
    </ng-template>
    @if (navTitle()) {
        <span class="nav-title">
            @if (navIcon()) {
                <span class="nav-icon" [class]="navIcon()"></span>
            }
            <span class="nav-title-text">{{ navTitle() }}</span>
        </span>
    }
    <ng-content></ng-content>
    <span class="spacer"></span>
    @if (displayName()) {
        <span class="nav-user-name">{{ displayName() }}</span>
    }
    <button class="nav-menu" mat-icon-button [matMenuTriggerFor]="menu">
        <span class="icon-down"></span>
    </button>
    <mat-menu #menu>
        @if (hasAccessToInteractives()) {
            <button mat-menu-item routerLink="/interactives">
                Interactives
            </button>
        }
        @if (hasAccessToProducerDashboard()) {
            <button mat-menu-item [routerLink]="producerLink()">
                Producer Dashboard
            </button>
        }
        @if (showHostViewLink()) {
            <button mat-menu-item [routerLink]="hostLink()">Host View</button>
        }
        @if (hasAccessToAdminPanel()) {
            <button mat-menu-item routerLink="/admin">Admin Panel</button>
        }
        @if (isAuthenticated()) {
            <button mat-menu-item (click)="signOut()">Logout</button>
        }
    </mat-menu>
</mat-toolbar>
